import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Loader from '../../components/Loader';
import { ProductRole } from '../../graphql/__generated__/typeDefs';
import { permissionGranted } from './permissions';
// helper to convert old context prop to match expected format
// from graphql-gateway (uppercase enums instead of lowercase)
export function toGatewayPermissionContext(_ref) {
  var loading = _ref.loading,
      organization = _ref.organization;
  return {
    loading: loading,
    organization: organization && {
      role: organization.role.toUpperCase(),
      products: organization.products.map(function (product) {
        return _objectSpread(_objectSpread({}, product), {}, {
          name: product.name.toUpperCase(),
          productRole: product.productRole && product.productRole.toUpperCase()
        });
      })
    }
  };
}
export function useProductAccessNeeded(product, context) {
  var _context$organization;

  // only link to activation if we've finished loading & know it's needed
  return !!(context && !context.loading && ((_context$organization = context.organization) === null || _context$organization === void 0 ? void 0 : _context$organization.products) && !hasProductAccess(context.organization.products, product));
}

function hasProductAccess(productsList, productName) {
  var productAccessRecord = productsList.find(function (p) {
    return p.name === productName;
  });
  return !!(productAccessRecord === null || productAccessRecord === void 0 ? void 0 : productAccessRecord.activated) && productAccessRecord.productRole !== ProductRole.NoAccess;
} // Hook to determine whether a user has been granted a given permission based on their current role


export function usePermission(requestedPermission, context) {
  return {
    loading: context === null || context === void 0 ? void 0 : context.loading,
    hasPermission: hasPermission(requestedPermission, context)
  };
}
export function hasPermission(requestedPermission, context) {
  if (context && !context.loading && context.organization) {
    var _context$organization2 = context.organization,
        role = _context$organization2.role,
        products = _context$organization2.products;
    return permissionGranted(requestedPermission, role, products);
  } else {
    return false;
  }
}
// Component which will conditionally render its children if the specified
// permission is granted to the current user
export var Protected = function Protected(_ref2) {
  var children = _ref2.children,
      permission = _ref2.permission,
      PermissionDeniedComponent = _ref2.PermissionDeniedComponent,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? {} : _ref2$context;

  var _usePermission = usePermission(permission, context),
      hasPermission = _usePermission.hasPermission,
      loading = _usePermission.loading;

  if (hasPermission) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  if (PermissionDeniedComponent) {
    return loading ? /*#__PURE__*/React.createElement(Loader, {
      active: true,
      inline: "centered",
      size: "large",
      "data-test-id": "loader"
    }) : /*#__PURE__*/React.createElement(PermissionDeniedComponent, null);
  }

  return null;
};